import { Card, CardContent } from "@/components/ui/card"

type FeatureCardProps = {
  title: string
  content: string
}

export function FeatureCard({ title, content }: FeatureCardProps) {
  return (
    <Card>
      <CardContent className="flex flex-col gap-2">
        <h3 className="text-sm font-semibold">{title}</h3>
        <p className="text-muted-foreground text-xs">{content}</p>
      </CardContent>
    </Card>
  )
}
